import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import CalculatorLoader from '../components/CalculatorLoader';

const CalculatorPage = () => {
  const { slug } = useParams();
  
  return (
      <div className="min-h-screen  py-8">
        <div className="container mx-auto px-4">
          <CalculatorLoader calculatorSlug={slug} />
        </div>
      </div>
  );
};

export default CalculatorPage;